module.exports = __webpack_public_path__ + "img/covid-vaccine-tracking-button.62618f68.png";